exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".form-wrapper[data-v-4a802fdb]{min-width:1200px}.breadcrumb-wrapper[data-v-4a802fdb]{margin-bottom:12px}.tip-text[data-v-4a802fdb]{margin-left:8px;color:#909399;font-size:12px}.tipsRed[data-v-4a802fdb]{color:red}.card-info[data-v-4a802fdb]{display:flex;flex-wrap:wrap;gap:8px 24px;padding:10px 14px;background:#f5f7fa;border-radius:4px;color:#606266;font-size:13px}.scheme-block[data-v-4a802fdb]{width:100%}.price-input-row[data-v-4a802fdb]{margin-top:6px;display:flex;align-items:center;flex-wrap:wrap;gap:8px}.computed-price[data-v-4a802fdb]{color:#f56c6c;font-weight:600}.bottom-tag-type[data-v-4a802fdb]{margin-bottom:6px}.bottom-tag-type .el-radio+.el-radio[data-v-4a802fdb]{margin-left:16px}.fixed-tag-text[data-v-4a802fdb]{height:60px;line-height:36px;color:#909399;font-size:13px}.tag-input>.el-input__inner[data-v-4a802fdb]{border-right:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-4a802fdb&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/OperationManage/UserAdminister/MemberPromotion/MemberPromotionDetail.vue
// module id = 516
// module chunks = 0